<ul class="horizontal-menu">
  <li class="mega-menu">
    <a href="javascript:void(0)" class="nav-link" [class.active]="navServices.megaMenu" (click)="megaMenuToggle()">
      <app-feather-icons [icon]="'layers'"></app-feather-icons>
      <span>Bonus Ui</span>
    </a>
    <div class="mega-menu-container nav-submenu menu-to-be-close" [class]="navServices.megaMenu ? 'd-block' : 'd-none'">
      <div class="container-fluid">
        <div class="row">
          <div class="col mega-box mobile-title d-none">
            <h5>Mega menu</h5>
            <button (click)="megaMenuToggle()" aria-label="Toggle Mega Menu">
              <i class="icon-x"></i>
            </button>
          </div>
          @for (megaItem of megaItems; track megaItem) {
            <div class="col mega-box">
              <button class="link-section icon" (click)="toggletNavActive(megaItem)"
                [class.active]="megaItem.active && navServices.megaMenuColapse"
                [attr.aria-expanded]="megaItem.active && navServices.megaMenuColapse ? 'true' : 'false'"
                [attr.aria-controls]="megaItem.title + '-menu'">
                <h6>{{megaItem.title}}</h6>
              </button>
              @if (megaItem.children) {
                <ul [class.d-none]="!megaItem.active && navServices.megaMenuColapse"
                  [id]="megaItem.title + '-menu'">
                  @for (childrenMegaItem of megaItem.children; track childrenMegaItem) {
                    <li>
                      <!-- Link -->
                      @if (childrenMegaItem.type === 'link') {
                        <a [routerLink]="!childrenMegaItem.type ? null : [childrenMegaItem.path]"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">
                          {{childrenMegaItem.title}}
                        </a>
                      }
                      <!-- External Link -->
                      @if (childrenMegaItem.type === 'extLink') {
                        <a href="{{ !childrenMegaItem.type ? null : childrenMegaItem.path }}"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">
                          {{childrenMegaItem.title}}
                        </a>
                      }
                      <!-- External Tab Link -->
                      @if (childrenMegaItem.type === 'extTabLink') {
                        <a href="{{ !childrenMegaItem.type ? null : childrenMegaItem.path }}" target="_blank" rel="noopener"
                          >
                          {{childrenMegaItem.title}}
                        </a>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </li>
  <li class="level-menu">
    <a class="nav-link" href="javascript:void(0)" [class.active]="navServices.levelMenu" (click)="levelMenuToggle()">
      <app-feather-icons [icon]="'inbox'"></app-feather-icons>
      <span>Level Menu</span>
    </a>
    <ul class="header-level-menu menu-to-be-close" [class]="navServices.levelMenu ? 'd-block' : 'd-none'">
      @for (levelmenuitem of levelmenuitems; track levelmenuitem) {
        <li>
          <!-- sub -->
          @if (levelmenuitem.type === 'sub') {
            <a href="javascript:void(0);">
              <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
              <span>{{levelmenuitem.title}}</span>
            </a>
          }
          <!-- Link -->
          @if (levelmenuitem.type === 'link') {
            <a [routerLink]="!levelmenuitem.type ? null : [levelmenuitem.path]"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
              <span>{{levelmenuitem.title}}</span>
            </a>
          }
          <!-- External Link -->
          @if (levelmenuitem.type === 'extLink') {
            <a href="{{ !levelmenuitem.type ? null : levelmenuitem.path }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}">
              <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
              <span>{{levelmenuitem.title}}</span>
            </a>
          }
          <!-- External Tab Link -->
          @if (levelmenuitem.type === 'extTabLink') {
            <a href="{{ !levelmenuitem.type ? null : levelmenuitem.path }}" target="_blank" rel="noopener"
              >
              <app-feather-icons [icon]="levelmenuitem.icon"></app-feather-icons>
              <span>{{levelmenuitem.title}}</span>
            </a>
          }
          @if (levelmenuitem.children) {
            <ul class="header-level-sub-menu">
              @for (childrenItem of levelmenuitem.children; track childrenItem) {
                <li>
                  <!-- Link -->
                  @if (childrenItem.type === 'link') {
                    <a [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}">
                      <app-feather-icons [icon]="childrenItem.icon"></app-feather-icons>
                      <span>{{childrenItem.title}}</span>
                    </a>
                  }
                  <!-- External Link -->
                  @if (childrenItem.type === 'extLink') {
                    <a href="{{ !childrenItem.type ? null : childrenItem.path }}"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}">
                      <app-feather-icons [icon]="childrenItem.icon"></app-feather-icons>
                      <span>{{childrenItem.title}}</span>
                    </a>
                  }
                  <!-- External Tab Link -->
                  @if (childrenItem.type === 'extTabLink') {
                    <a href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank" rel="noopener"
                      >
                      <app-feather-icons [icon]="childrenItem.icon"></app-feather-icons>
                      <span>{{childrenItem.title}}</span>
                    </a>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </li>
</ul>